import PropTypes from "prop-types"
import React from "react"
import { Row, Col, Card, CardBody, Container, Form } from "reactstrap"

import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Validation
import * as Yup from "yup"

// import images
import profile from "../../assets/images/profile-img.png"
import logoIcon from "assets/images/logo-icon.png"

// import form
import InputRHF from "components/RHF/InputRHF"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { useMutation } from "@tanstack/react-query"
import { toast } from "react-toastify"
import LoadingButton from "components/Common/LoadingButton"
import { userForgotPassword } from "api/authApi"
import { t } from "i18next"

const ForgetPasswordPage = () => {
  //meta title
  document.title = "Forget Password | Teleman"

  const validationSchema = Yup.object({
    email: Yup.string().required("Please Enter Your Email"),
  })

  const { handleSubmit, control } = useForm({
    defaultValues: {
      email: "",
    },
    resolver: yupResolver(validationSchema),
  })

  const { mutate, isPending } = useMutation({
    mutationFn: userForgotPassword,
    onSuccess: () => {
      toast.success("details have been sent to your email")
    },
    onError: error => toast.error(error),
  })

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("forget Password")}</h5>
                        <p>{t("sign in to continue to pixamo")}.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="image" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="logo-light-element">
                    <div className="avatar-md profile-user-wid mb-4">
                      <span className="avatar-title rounded-circle bg-light">
                        <img src={logoIcon} alt="logo" height="38" />
                      </span>
                    </div>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={handleSubmit(mutate)}
                    >
                      <InputRHF
                        name="email"
                        label={t("email")}
                        placeholder={t("enter email")}
                        control={control}
                      />

                      <Row className="mb-3">
                        <Col className="text-end">
                          <LoadingButton isLoading={isPending} type="submit">
                            {t("forget")}
                          </LoadingButton>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("go back to")}
                  <Link
                    to="/login"
                    className="font-weight-medium text-primary ms-1"
                  >
                    {t("Login")}
                  </Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
